<template>
  <div class="fixed right-0 bottom-0 left-0 sm:left-auto sm:bottom-10 sm:right-10 p-6 sm:max-w-2xl text-white bg-orange-500">
    A new version of the application is available.<br />
    Please <a href="#" onclick="window.location.reload(true)" class="text-black underline">refresh</a> to get the newest updates.
  </div>
</template>

<script>
export default {
  name: 'NewVersionNotification'
}
</script>
